import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../Auth/AuthContext';
import ImageSwiper from '../Community/ImageSwiper';
import ShoppingList from './ShoppingList';
import { openRecipeInChat } from '../utils/openRecipeInChat';
import { formatIngredient } from '../utils/formatIngredient';
import getRecipeId from '../utils/getRecipeId';
import { useToast } from '../context/ToastContext';
import savedIcon from '../Icons/saved1.png';
import ListaCompraGreen from '../Icons/ListaCompraGreen.png';
import cameraIcon from '../Icons/camara.jpg';
import COOKY_ICON from '../Icons/CookyChat_Oficial_cir.png'; // <- importar como los demás
import { usePlan } from '../context/PlanContext';
import AddToRecetarioModal from './AddToRecetarioModal';
import './SavedRecipeCard.css';

const DIFF_CONFIG = {
  'fácil':   { label: 'Fácil',   color: '#e8f5e9', text: '#2e7d32' },
  'facil':   { label: 'Fácil',   color: '#e8f5e9', text: '#2e7d32' },
  'media':   { label: 'Media',   color: '#fff8e1', text: '#f57f17' },
  'difícil': { label: 'Difícil', color: '#fce4ec', text: '#c62828' },
  'dificil': { label: 'Difícil', color: '#fce4ec', text: '#c62828' },
};

const SavedRecipeCard = ({ recipe, onRemove, onRecetariosChanged }) => {
  const { userId }    = useAuth();
  const { showToast } = useToast();
  const navigate      = useNavigate();
  const { isPremium, showUpgradeModal } = usePlan();

  const [expanded,        setExpanded]        = useState(false);
  const [showShoppingList, setShowShoppingList] = useState(false);
  const [showRecetarioModal, setShowRecetarioModal] = useState(false);

  const id   = getRecipeId(recipe);
  const diff = DIFF_CONFIG[(recipe.dificultad || '').toLowerCase()];
  const ings = Array.isArray(recipe.ingredientes) ? recipe.ingredientes : [];

  const goToRecipe = () => {
    if (id) navigate(`/recipe/${id}`);
    else showToast('Esta receta no tiene página de detalle disponible.');
  };

  const canOpenInChat    = true; // visible en todas las recetas guardadas

  return (
    <div className="src-card">

      {/* ── Imagen ────────────────────────────────────────── */}
      <div className="src-img-wrapper" onClick={goToRecipe}>
        <ImageSwiper
          imagenes={recipe.imagenes}
          imagen={recipe.imagen || cameraIcon}
          nombre={recipe.nombre}
        />
      </div>

      {/* ── Contenido ─────────────────────────────────────── */}
      <div className="src-body">

        {/* Título */}
        <h3 className="src-title" onClick={goToRecipe}>
          {recipe.nombre}
        </h3>

        {/* Dificultad chip */}
        {diff && (
          <span
            className="src-diff-chip"
            style={{ background: diff.color, color: diff.text }}
          >
            {diff.label}
          </span>
        )}

        {/* Ingredientes expandibles */}
        {ings.length > 0 && (
          <div className="src-ings">
            <button
              className="src-ings-toggle"
              onClick={() => setExpanded(v => !v)}
            >
              <span>Ingredientes</span>
              <span className={`src-chevron${expanded ? ' open' : ''}`}>›</span>
            </button>
            {expanded && (
              <ul className="src-ings-list">
                {ings.map((ing, i) => (
                  <li key={i}>{formatIngredient(ing)}</li>
                ))}
              </ul>
            )}
          </div>
        )}

        {/* Lista de la compra expandible */}
        {showShoppingList && (
          <div className="src-shopping">
            <ShoppingList ingredientes={ings} />
          </div>
        )}
      </div>

      {/* ── Acciones ──────────────────────────────────────── */}
      <div className="src-actions">
        {/* Lista compra */}
        <button
          className="src-action-btn"
          onClick={() => setShowShoppingList(v => !v)}
          title="Lista de la compra"
        >
          <img src={ListaCompraGreen} alt="Lista compra" className="src-action-icon src-action-icon-lista" />
          <span>Lista</span>
        </button>

        {/* Guardar / Eliminar */}
        <button
          className="src-action-btn"
          onClick={() => onRemove(recipe)}
          title="Eliminar de guardados"
        >
          <img src={savedIcon} alt="Guardada" className="src-action-icon" />
          <span>Guardada</span>
        </button>

        {/* Chef IA — Premium only */}
        {canOpenInChat && (
          <button
            className={`src-action-btn src-action-ai${!isPremium ? ' src-action-ai--locked' : ''}`}
            onClick={() => {
              if (!isPremium) {
                showUpgradeModal('aiRecipeChat');
                return;
              }
              openRecipeInChat(recipe, userId, navigate);
            }}
            title={isPremium ? 'Hablar con IA sobre esta receta' : 'Disponible con Premium'}
          >
            <img src={COOKY_ICON} alt="Chef IA" className="src-action-icon src-action-icon-cooky" />
            <span>Chef IA</span>
          </button>
        )}

        {/* Añadir a recetario */}
        <button
          className="src-action-btn"
          onClick={() => setShowRecetarioModal(true)}
          title="Añadir a recetario"
        >
          <span style={{ fontSize: '1.2em' }}>📚</span>
          <span>Recetario</span>
        </button>
      </div>

      {showRecetarioModal && (
        <AddToRecetarioModal
          recipe={recipe}
          onClose={() => setShowRecetarioModal(false)}
          onSaved={() => onRecetariosChanged?.()}
        />
      )}

    </div>
  );
};

export default SavedRecipeCard;